import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { throttle } from '@ajaibid/utils';
import { primaryLight, primary } from '@/colors/colorsV1';

const throttleTimeInMilisecond = 300;

const CarouselList = props => {
  const { dataResults, indexSlide, slideActive, setSlideActive, slideId } =
    props;

  const widthCard = 245;
  const totalWidth = dataResults * widthCard;

  const throttledSetSlideActive = useMemo(indexSlide => {
    throttle(() => setSlideActive(indexSlide), throttleTimeInMilisecond);
  }, []);

  return (
    <div
      onClick={() => {
        const container = document.getElementById(slideId);
        if (indexSlide === 0) {
          container.scroll({ left: 0, behavior: 'smooth' });
        } else {
          const width = totalWidth - (dataResults - indexSlide * 4) * widthCard;
          container.scroll({ left: width, behavior: 'smooth' });
        }
        throttledSetSlideActive(indexSlide);
      }}
      style={{
        width: slideActive === indexSlide ? 20 : 8,
        height: 7,
        backgroundColor: slideActive === indexSlide ? primary : primaryLight,
        margin: '0 4px',
        borderRadius: 8
      }}
      role="button"
    />
  );
};

CarouselList.propTypes = {
  dataResults: PropTypes.number.isRequired,
  indexSlide: PropTypes.number.isRequired,
  slideActive: PropTypes.number.isRequired,
  setSlideActive: PropTypes.func.isRequired,
  slideId: PropTypes.string.isRequired
};

export default CarouselList;
